export class GetMovimentOrderRequest {
    public branchCode!: number;
    public cicleCode!: number;
    public orderCode!: number;
    public referenceId!: string;
    public placeCode!: number;
    public programSequence!: number;
  }

  export class GetMovimentOrderCompleteRequest {
    public branchCode!: number;
    public cicleCode!: number;
    public orderCode!: number;
    public placeCode!: number;
  }

  export class GetMovimentTomasRequest {
    public branchCode!: number;
    public tokenTomas!: string;
    public content!: string;
  }

  export class GetPrintRemessaRequest {
    public branchCode!: number;
    public shipmentCode!: number;
    public withMaterial !: boolean;
    public WithService !: boolean;
    public WithValueService !: boolean;
    public WithFooterSignature !: boolean;
    public WithGridAnotation !: boolean;
    public WithAddressSupplier !: boolean;
  }
